import React, { useEffect, useState } from "react"
import { Input as InputBase } from "@stardust-ds/react"

import Label from "../Label"
import styles from "./index.module.scss"
import MoveEllipsisIcon from "../../../assets/icons/MoveEllipsisIcon"
import DownArrow from "../../../assets/icons/DownArrow"
import Search from "antd/es/input/Search"
import SearchIcon from "../../../assets/icons/SearchIcon"
import CloseIcon from "../../../assets/icons/CloseIcon"

const Input = React.forwardRef((props, ref) => {
  const {
    label,
    bIsDraggable,
    className,
    type,
    max = 100,
    min = 0,
    onChange,
    defaultValue,
    isFullWidth,
    isSearch = false,
    disabled = false,
    fnResetSearch = () => {},
    ...rest
  } = props
  const [nDecimalValue, fnSetNDecimalValue] = useState(defaultValue)

  useEffect(() => {
    fnSetNDecimalValue(defaultValue)
  }, [defaultValue])

  const cClass = `${styles.input} ${className ? className : ""} inputDecimals`

  function fnDecrementDecimals(e) {
    e.stopPropagation()
    e.preventDefault()
    if (nDecimalValue - 1 < min) return
    fnSetNDecimalValue(nDecimalValue - 1)
    onChange(nDecimalValue - 1)
  }

  function fnHandleInputValue(e) {
    if (e.target.value === "" || Number(e.target.value) === min - 1) {
      fnSetNDecimalValue(null)
      onChange(null)
      return
    }
    if (Number(e.target.value) < min) {
      onChange(null)
      fnSetNDecimalValue(null)
      return
    }
    if (Number(e.target.value) <= max) {
      fnSetNDecimalValue(Number(e.target.value))
      onChange(Number(e.target.value))
      return
    }
    onChange(null)
    return
  }

  function fnHandleKeyPress(e) {
    const regex = /^\d+$/

    if (!regex.test(e.key)) {
      e.preventDefault()
    }
  }

  function fnIncreaseDecimals(e) {
    e.stopPropagation()
    e.preventDefault()
    if (nDecimalValue + 1 <= max) {
      fnSetNDecimalValue(nDecimalValue + 1)
      onChange(nDecimalValue + 1)
      return
    }
  }
  return (
    <>
      {bIsDraggable ? (
        <div className={styles.draggableComponent}>
          <MoveEllipsisIcon />
          <Label className={styles.label}>{label}</Label>
        </div>
      ) : (
        <Label className={styles.label}>{label}</Label>
      )}
      {type !== "number" ? (
        <div style={{ position: "relative" }}>
          {isSearch && (
            <SearchIcon
              fill="#ACB4BA"
              style={{
                position: "absolute",
                top: "0.7rem",
                left: "1.3rem",
                width: "1.2rem",
              }}
            />
          )}

          <InputBase
            id="inputBase"
            ref={ref}
            className={cClass}
            bColor={"#6CB6E3"}
            type={type}
            disabled={disabled}
            onChange={onChange}
            isFullWidth={isFullWidth}
            autoComplete="off"
            {...rest}
          />
          {isSearch && (
            <CloseIcon
              fill="#ACB4BA"
              style={{
                position: "absolute",
                top: "0.65rem",
                right: "1.3rem",
                width: "1.2rem",
                cursor: "pointer",
              }}
              onClick={fnResetSearch}
            />
          )}
        </div>
      ) : (
        <div
          className={`${styles.decimals}`}
          style={{
            width: isFullWidth ? "100%" : "min-content",
          }}
        >
          <input
            style={{
              width: isFullWidth ? "100%" : "100px",
              cursor: disabled ? "not-allowed" : "",
            }}
            data-testid="input-decimals"
            ref={ref}
            className={cClass}
            min={min}
            max={max}
            value={nDecimalValue}
            defaultValue={nDecimalValue}
            onChange={fnHandleInputValue}
            disabled={disabled}
            onKeyPress={fnHandleKeyPress}
            autoComplete="off"
            {...rest}
          />
          <div
            className={styles.arrowsInputContainer}
            disabled={disabled}
            style={{ pointerEvents: disabled ? "none" : "auto" }}
          >
            <DownArrow
              fill={"#6CB6E3"}
              style={{ transform: "rotate(180deg)" }}
              onClick={(e) => fnIncreaseDecimals(e)}
            />
            <DownArrow fill={"#6CB6E3"} onClick={(e) => fnDecrementDecimals(e)} />
          </div>
        </div>
      )}
    </>
  )
})

Input.displayName = "Input"

export default Input
